<template>
  <div
    :class="classes"
    v-html="svg" />
</template>

<script>
import icons from './icons'

export default {
  props: {
    icon: {
      type: String,
      required: true,
      default: 'soho'
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: value => ['tiny', 'small', 'medium', 'large'].includes(value)
    },

    // Used for colouring.  If present and a valid house, will colour
    // the icon to the colour of the house
    house: {
      type: String,
      required: false
    }
  },
  computed: {
    svg () {
      if (this.icon.indexOf('://') >= 0) {
        return `<img src="${this.icon}" alt="" />`
      }

      const svg = icons[this.icon]

      return svg || ''
    },
    classes () {
      const classes = {
        [this.size]: true
      }
      if (this.house) {
        classes[`soho-svg-${this.house}`] = true
      }

      classes.icon = true

      return classes
    }
  }
}
</script>

<style lang="scss" scoped>
$d-base: 8px;

$d-x-small: $d-base * 2;
$d-small: $d-base * 3;
$d-med-small: $d-base * 4;
$d-x-large: $d-base * 8;

.icon {
  display: inline-block;
  width: $d-med-small;
  height: $d-med-small;

  &.tiny {
    width: $d-x-small;
    height: $d-x-small;
  }

  &.small {
    width: $d-small;
    height: $d-small;
  }

  .medium {
    width: $d-med-small;
    height: $d-med-small;
  }

  &.large {
    width: $d-x-large;
    height: $d-x-large;
  }

  ::v-deep svg, ::v-deep img {
    display: block;
    margin: 0 auto;
    height: 100%;
    width:  100%;
  }
}

.icon {
  fill: $deprecated-grey-xx-dark;
}
</style>
